import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, CircularProgress } from '@mui/material';

// ROUTES
import PublicRoute from '@/routes/help/PublicRoute';
import PrivetRoute from '@/routes/help/PrivateRoute';

// COMPONENTS
import SideMenu from '@/components/SideMenu';
import Loader from '@/components/Loader';

// STYLES
import { AuthWrapper, Wrapper, ProgressWrap } from './styles';

const loader = (
  <ProgressWrap className="loader">
    <CircularProgress />
  </ProgressWrap>
);

const RouterLayout = props => {
  const {
    type = '',
    component: Component,
    componentProps = {},
    isAuth,
    protection = false,
    user,
    role,
    loading,
    allowedRoles = [],
    ...rest
  } = props;
  let Structure;

  switch (type) {
    case 'auth':
      Structure = (
        <AuthWrapper container>
          <Grid size={12}>
            <Suspense fallback={loader}>
              <Component {...componentProps} />
            </Suspense>
          </Grid>
        </AuthWrapper>
      );
      break;
    case 'dashboard':
      Structure = (
        <Grid container wrap="nowrap" direction="row">
          <SideMenu />
          <Wrapper size={12}>
            <Suspense fallback={loader}>{!!user && <Component {...componentProps} />}</Suspense>
          </Wrapper>
          <Loader active={loading} zIndex="1201" fullFilled position="fixed" />
        </Grid>
      );
      break;
    case 'document':
      Structure = (
        <Suspense fallback={loader}>
          <Component {...componentProps} />
        </Suspense>
      );
      break;
    default:
      Structure = (
        <Suspense fallback={loader}>
          <Component {...componentProps} />
        </Suspense>
      );
  }

  return protection ? (
    <PrivetRoute
      {...rest}
      allowedRoles={allowedRoles}
      isAuth={isAuth}
      role={role}
      component={Structure}
    />
  ) : (
    <PublicRoute
      {...rest}
      allowedRoles={allowedRoles}
      isAuth={isAuth}
      role={role}
      component={Structure}
    />
  );
};

RouterLayout.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  allowedRoles: PropTypes.array,
  protection: PropTypes.bool,
  isAuth: PropTypes.bool,
  component: PropTypes.object,
  componentProps: PropTypes.object,
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.oneOf([null])]),
  loading: PropTypes.bool.isRequired,
  role: PropTypes.array,
};

const mapStateToProps = ({ auth, app }) => ({
  isAuth: auth.isAuth,
  user: auth.user,
  role: (auth.user && auth.user.role) || [],
  loading: auth.loading || auth.loginAsLoading || app.loadings.switchPartner,
});

export default connect(mapStateToProps)(RouterLayout);
